import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimWebFontLoader } from './trim.web-font-loader';
import { TrimUiManager } from '../ui/trim.ui.manager';
import { Env } from '../../../models/env';

export const loader = new TrimWebFontLoader({});

export class TrimWebFontManager implements ITrimEditorManagerBase {

  private uiManager!: TrimUiManager;

  constructor() {
  }

  di(uiManager: TrimUiManager): void {
    this.uiManager = uiManager;
  }

  initialize() {
    this.uiManager.on('t->r:web-font:download', (e) => {
      this.loadFont(e.fontFamilyName)
        .then(() => {
          e.callback();
        }).catch((res) => {
        console.log(res);
        e.error(res);
      });
    });
    this.uiManager.on('t->r:web-font:get-list', (e) => {
      this.getFontList()
        .then((v) => {
          e.callback({ fonts: v });
        });
    });
  }

  destroy(): void {
    this.uiManager.off('t->r:web-font:download');
    this.uiManager.off('t->r:web-font:get-list');
  }

  loadFont(fontFamilyName: string) {
    const fileName = 'labo_fonts.css';
    const fontsCssUrl = `${Env.api.font.protocol}://${Env.api.font.host}/${fileName}`;
    return new Promise<void>((resolve, reject) => {
      loader.load({
        retry: 3,
        timeout: Env.config.webfontTimeoutMs,
        familyName: fontFamilyName,
        css: fontsCssUrl,
        onLoad: () => resolve(),
        onError: () => reject(`フォントの読み込みに失敗しました。 : ${fontFamilyName}`),
      });
    });
  }

  getFontList(): Promise<string[]> {
    const fileName = 'labo_fonts.json';
    const fontsJsonUrl = `${Env.api.font.protocol}://${Env.api.font.host}/${fileName}`;
    return fetch(fontsJsonUrl, { mode: 'cors' })
      .then((res) => res.json())
      .then((json) => {
        return json.map((v: any) => v.familyName);
      });
  }

}
